export const API_URL = `${process.env.REACT_APP_API_URL}/api`;
export const AUTH_TOKEN_STORAGE_KEY = 'game-of-life-auth-token';
